import { PRIVACY_POLICY } from "@/data/member_agreement";

export default function PrivacyPolicy() {
  const renderContent = (item: { text: string }) => {
    return <p className="typography indentation-undefined">{item.text}</p>;
  };
  return (
    <div className="w-full max-w-full-size flex flex-col items-center px-[24px] py-[10px] tablet:px-[120px] tablet:py-[20px] text-[#17191c]">
      <div className="font-pre-bold text-[#17191c] text-[22px] font-medium mt-[117px] mb-[32px]">
        개인정보 처리방침
      </div>
      <div className="h-[32px]" />
      <div className="flex flex-col items-stretch gap-[20px]">
        {PRIVACY_POLICY.map((data, index) => (
          <div key={index} style={{ marginBottom: 24 }}>
            {data.title !== "" && (
              <>
                <div className="font-pre-medium text-[#17191c] subtitle">
                  {data.title}
                </div>
                <div className="h-[8px]" />
              </>
            )}
            <div className="gap-[8px]">
              {data.contents.map((item, idx) => (
                <div key={idx}>{renderContent(item)}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
